module.exports = __webpack_public_path__ + "img/banner-two12.7f345df1.png";